<script>
import { SvgIcon } from '@leapsight/styleguide'

export default {
  name: 'BaseContextualMenuOnMap',
  components: { SvgIcon },
  props: ['googleMap'],
  created() {
    this.setContextualMenu()
  },
  mounted() {
    window.addEventListener('resize', this.resize)
    this.$nextTick(function() {
      this.resize()
    })
  },
  data() {
    return {
      showMenu: false,
      measureMenuPosition: { x: 0, y: 0 },
      contextualMenuPosition: {
        x: 0,
        y: 0
      },
      coordinates: { lat: 0, lng: 0 },
      showMeasureDistanceMenu: false,
      polyline: new google.maps.Polyline({
        path: [],
        map: this.$store.state.map,
        editable: true,
        geodesic: true,
        strokeOpacity: 0.5,
        strokeWeight: 2
      }),
      clickOnMapListener: null,
      lineSymbol: {
        path: 'M0 0 h6',
        scale: 1
      },
      closeArrow: {
        path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
        scale: 3,
        fillOpacity: 0.7,
        strokeColor: 'black'
      },
      openArrow: {
        path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
        scale: 3,
        fillOpacity: 0.7,
        strokeColor: 'black',
        rotation: 180
      },
      totalDistance: 0,
      markers: [],
      clickListener: null
    }
  },
  computed: {
    showCoordinates() {
      return `${this.coordinates.lat},${this.coordinates.lng}`
    }
  },
  methods: {
    updateDistances() {
      const path = this.polyline.getPath()
      const distances = []
      this.markers.forEach(m => m.setMap(null))
      this.markers = []
      for (let i = 1; i < path.length; i++) {
        const distance =
          google.maps.geometry.spherical.computeDistanceBetween(
            path.getAt(i - 1),
            path.getAt(i)
          ) / 1000
        distances.push(distance)

        // Crear un marcador en el punto medio y establecer la distancia
        const midpoint = google.maps.geometry.spherical.interpolate(
          path.getAt(i - 1),
          path.getAt(i),
          0.5
        )
        const marker = new google.maps.Marker({
          position: midpoint,
          map: this.$store.state.map,
          label: {
            text: distance.toFixed(2) + ' km',
            color: 'black',
            fontSize: '16px'
          },
          icon: {
            url: '',
            scaledSize: new google.maps.Size(0, 0)
          },
          zIndex: 100
        })
        this.markers.push(marker)
      }
    },
    calculateTotalDistance() {
      const path = this.polyline.getPath()
      const distanceInMeters = google.maps.geometry.spherical.computeLength(
        path
      )
      const distanceInKm = distanceInMeters / 1000
      return distanceInKm.toFixed(2)
    },
    resize() {
      const rect = this.googleMap.getBoundingClientRect()

      this.measureMenuPosition = {
        x: rect.left + rect.width / 2 - 90,
        y: rect.top + rect.height + 20
      }
    },
    setContextualMenu() {
      this.$store.state.map.addListener('rightclick', e => {
        this.showMenu = false

        this.coordinates.lat = e.latLng.lat()
        this.coordinates.lng = e.latLng.lng()

        this.showMenu = true
      })
      document.addEventListener('contextmenu', event => {
        event.preventDefault()

        this.contextualMenuPosition.x = event.clientX
        this.contextualMenuPosition.y = event.clientY
      })
    },
    closeMeasureMenu() {
      this.showMeasureDistanceMenu = false
      this.markers.forEach(label => label.setMap(null))
      this.markers = []
      google.maps.event.removeListener(this.clickListener)

      this.polyline.setMap(null)
      this.polyline = new google.maps.Polyline({
        path: [],
        map: this.$store.state.map,
        editable: true,
        geodesic: true,
        strokeOpacity: 0.5,
        strokeWeight: 2
      })
    },
    measureDistanceOpen() {
      this.showMeasureDistanceMenu = false
      this.totalDistance = 0

      this.polyline.setOptions({
        icons: [
          {
            icon: this.lineSymbol,
            offset: '0%',
            repeat: '30px'
          },
          {
            icon: this.openArrow,
            offset: '0%'
          },
          {
            icon: this.closeArrow,
            offset: '100%'
          }
        ]
      })

      this.clickListener = this.$store.state.map.addListener('click', event => {
        this.polyline.getPath().push(event.latLng)
        this.totalDistance = this.calculateTotalDistance()
        this.updateDistances()
      })

      this.polyline.addListener('mouseup', () => {
        this.totalDistance = this.calculateTotalDistance()
        this.updateDistances()
      })

      this.showMeasureDistanceMenu = true
    }
  }
}
</script>

<template>
  <div>
    <v-menu
      v-model="showMenu"
      :position-x="contextualMenuPosition.x"
      :position-y="contextualMenuPosition.y"
      absolute
      offset-y
      transition="scale-transition"
    >
      <v-card>
        <v-list class="ma-0 pa-0">
          <v-list-item>
            <v-list-item-title>{{ showCoordinates }}</v-list-item-title>
          </v-list-item>
        </v-list>

        <v-list class="ma-0 pa-0">
          <v-list-item link>
            <v-list-item-title
              v-if="!showMeasureDistanceMenu"
              @click="measureDistanceOpen()"
              >
              {{ 
                $t(
                  'fleet_management.geofences.map.labels.measure_distance'
                )
              }}
              </v-list-item-title
            >
            <v-list-item-title v-else @click="closeMeasureMenu()"
              >
              {{ 
                $t(
                  'fleet_management.geofences.map.labels.delete_measurement'
                )
              }}
              </v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>

    <v-menu
      v-model="showMeasureDistanceMenu"
      :close-on-content-click="false"
      :close-on-click="false"
      :close-delay="false"
      :position-x="measureMenuPosition.x"
      :position-y="measureMenuPosition.y"
      top
      absolute
      offset-y
      offset-x
      transition="scale-transition"
    >
      <v-card class="pa-1 rounded-lg" width="300">
        <div class="d-flex">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="secondary--text h1 font-weight-bold">
                {{ 
                  $t(
                    'fleet_management.geofences.map.labels.measure_distance'
                  )
                }}
              </v-list-item-title>
              <v-list-item-subtitle class="secondary--text">
                {{ 
                  $t(
                    'fleet_management.geofences.map.labels.click_map_enlarge_the_route'
                  )
                }}
              </v-list-item-subtitle>
              <v-list-item-subtitle class="secondary--text mt-3">
                {{ 
                  $t(
                    'fleet_management.geofences.map.labels.total_distance', { distance: totalDistance }
                    ) 
                }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-btn icon small @click="closeMeasureMenu">
            <SvgIcon class="secondary--text" iconType="icon_close_circle" />
          </v-btn>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<style lang="scss" scoped>
#meaureMenu {
  position: absolute;
  top: 25%;
  @media (min-width: 961px) and (max-width: 1264px) {
    top: 10%;
  }
  @media (min-width: 1265px) and (max-width: 1823px) {
    top: 15%;
  }
  @media (min-width: 1824px) {
    top: 25%;
  }
  right: 67px;

  .text-caption {
    font-size: 0.625rem !important;
    letter-spacing: normal !important;
  }
}
</style>
